import { Box, Flex, HStack, IconButton, Text, VStack } from '@chakra-ui/react';
import {
    MdPerson
} from 'react-icons/md';
import { Handle, Position } from 'reactflow';
import { FiCopy, FiEdit, FiTrash2 } from 'react-icons/fi';

export const UpdateProfileNode = ({ data }) => {
    return (
        <Box
            borderWidth="2px"
            borderColor="green.500"
            borderRadius="xl"
            bg="white"
            boxShadow={data.selected ? 'xl' : 'lg'}
            minW="240px"
        >
            <Handle type="target" position={Position.Left} style={{  background: 'black' }} />

            <Flex
                bg="green.500"
                color="white"
                px={4}
                py={2.5}
                borderTopRadius="xl"
                align="center"
                gap={2}
            >
                <MdPerson size={16} />
                <Text noOfLines={1} flex={1} fontSize="sm" fontWeight="medium">Update Profile</Text>
                <HStack spacing={1}>
                    <IconButton
                        icon={<FiEdit size={14} />}
                        size="xs"
                        variant="ghost"
                        color="white"
                        onClick={(e) => { e.stopPropagation(); data.onEdit?.(data.id); }}
                    />
                    <IconButton
                        icon={<FiCopy size={14} />}
                        size="xs"
                        variant="ghost"
                        color="white"
                        onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
                    />
                    <IconButton
                        icon={<FiTrash2 size={14} />}
                        size="xs"
                        variant="ghost"
                        color="white"
                        onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
                    />
                </HStack>
            </Flex>

            <Box p={3.5}>
                <Text fontSize="sm" fontWeight="medium" mb={1.5}>{data.label || 'Update Customer Profile'}</Text>
                {data.tagName ? (
                    <VStack spacing={1} mt={2} align="stretch">
                        <Box
                            fontSize="xs"
                            bg="green.50"
                            color="green.700"
                            borderWidth="1px"
                            borderColor="green.200"
                            borderRadius="md"
                            px={2}
                            py={1}
                        >
                            <Text as="span" fontWeight="medium">Tag:</Text> {data.tagName}
                        </Box>
                        {data.tagValue && (
                            <Text fontSize="xs" color="gray.600">
                                Value: {data.tagValue}
                            </Text>
                        )}
                    </VStack>
                ) : (
                    <Text fontSize="xs" color="gray.600" mt={2} fontStyle="italic">
                        Tag not configured
                    </Text>
                )}
            </Box>

            <Handle type="source" position={Position.Right} style={{ background: 'black' }} />
        </Box>
    );
};
